<template>
  <div class="visited-box">
    <div class="title-box">
      <h2 class="v-title">{{ $t('mbs-select-places') }}</h2>
      <p @click="() => this.$router.push('/account/places')">{{ $t('btn-back') }}</p>
    </div>
    <div class="mobile-title-box" @click="() => this.$router.push('/account/places')">
      <img src="~img/back.png" alt="back" />
      <div class="back">{{ $t('back') }}</div>
    </div>
    <div class="v-content">
      <img :src="info.image" alt="img" />
      <div class="v-charges">
        <div>
          <p>{{ $t('total-visit') }}</p>
          <p>{{ info.personCount }}</p>
        </div>
        <div>
          <p>{{ `${$t('paid-visit')} ${info.unitPrice}` }}</p>
          <p>{{ info.buyPoint }}</p>
        </div>
        <div>
          <p>{{ $t('total-charges') }}</p>
          <p>{{ info.totalCharges ? info.totalCharges : 0 }}</p>
        </div>
      </div>
    </div>
    <div class="v-detail">
      <div>
        <p>{{ $t('airport') }}</p>
        <p>{{ info.airportName }}</p>
      </div>
      <div>
        <p>{{ $t('visited-date') }}</p>
        <p>{{ info.dateEn }}</p>
      </div>
      <div>
        <p v-if="info.loungeClass === 'lounge'">{{ $t('lounge') }}</p>
        <p v-if="info.loungeClass === 'dining'">{{ $t('dining') }}</p>
        <p>
          {{ info.restroomName }} <br />
          {{ info.terminal }}, {{ info.area }}
        </p>
      </div>
      <div>
        <p>{{ $t('dp-num') }}</p>
        <p>{{ info.formatCode }}</p>
      </div>
      <div>
        <p>{{ $t('reference-num') }}</p>
        <p>{{ info.no }}</p>
      </div>
    </div>
    <div class="btn-list">
      <p v-if="currentIndex !== 0" @click="getCsList('1')">{{ $t('btn-previous') }}</p>
      <p v-if="currentIndex !== listLength - 1" @click="getCsList('2')">{{ $t('btn-next') }}</p>
    </div>
  </div>
</template>

<script>
  import { getQueryString, formatDateEN, formatCardNo } from '@/utils';
  import { mapState } from 'vuex';

  export default {
    name: 'details',
    data() {
      return {
        info: {},
        list: [],
        currentIndex: 0,
        listLength: 0,
      };
    },
    computed: {
      ...mapState(['userInfo']),
    },
    watch: {
      $route: {
        handler() {
          this.initData();
        },
        deep: true,
      },
    },
    mounted() {
      this.initData();
    },
    beforeUnmount() {
      sessionStorage.removeItem('visitedData');
    },
    methods: {
      // 初始化数据
      initData() {
        this.currentIndex = getQueryString('currentIndex')
          ? parseInt(getQueryString('currentIndex'))
          : 0;
        this.listLength = getQueryString('length') ? parseInt(getQueryString('length')) : 0;
        const visitedData = sessionStorage.getItem('visitedData');
        if (visitedData && visitedData !== '{}') {
          this.info = JSON.parse(visitedData);
          this.info.formatCode = formatCardNo(this.info.dragoncode);
          this.info.dateEn = this.info.date ? formatDateEN(new Date(this.info.date)) : '';
        }
      },
      // 获取消费记录列表
      async getCsList(type) {
        this.$loading.show();
        const { userId, sessionId } = this.userInfo;
        const data = {
          lang: localStorage.getItem('lang') || 'en_US',
          userId,
          sessionId,
        };
        try {
          const res = await this.$http.account.getCsList(data);
          if (res?.state === '11') {
            this.$loading.hide();
            if (res?.recordList?.length > 0) {
              this.list = res.recordList;
              res.recordList.map((v, i) => {
                if (v.no === this.info.no) {
                  // 去到上一页或下一页
                  const index = type === '1' ? i - 1 : i + 1;
                  sessionStorage.setItem('visitedData', JSON.stringify(res.recordList[index]));
                  const { length } = res.recordList;
                  this.$router.push({
                    path: '/account/places/visited',
                    query: { currentIndex: index, length },
                  });
                }
                return {};
              });
            } else {
              this.list = [];
            }
          } else {
            this.$loading.hide();
            if (res.note) {
              this.$messageModal.show({
                image: false,
                desc: res.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
              });
            }
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './details.scss';
</style>
